/* eslint-disable */
import Vue from 'vue'
import App from './App/index';
import VueRouter from 'vue-router';
import router from './route';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import moment from 'moment';
import store from './store/store.js';
import customDirective from './_helpers/custom.directive';
import interceptor from './services/interceptor';
import timestamp from './services/timestamp';
import draggable from "vuedraggable";
import VTooltip from 'v-tooltip'

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/extra.css';
import './assets/fonts/alien/stylesheet.css';
import './assets/fonts/acssans/stylesheet.css';
import './assets/fonts/beon/stylesheet.css';
import './assets/fonts/myrid-pro/stylesheet.css';
import 'highlight.js/styles/atom-one-dark.css';
import 'highlight.js/lib/languages/python';
import 'highlight.js/lib/languages/cpp';
import 'highlight.js/lib/languages/vbscript';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import './assets/css/tooltip.css';


// Global Varible
export const bus = new Vue();
window.axios = axios
window.token = localStorage.getItem('token');
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
if (window.token != '' && window.token != null) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
}

Vue.config.productionTip = false
Vue.use(VueRouter);
Vue.use(VTooltip);
Vue.use(VeeValidate, {
  validity: true
});
store.dispatch('getAuthHeader');
const scriptLoader = {
  loaded: [],
  load(src) {
    if (this.loaded.indexOf(src) !== -1) {
      return
    }
    this.loaded.push(src)
    if (document) {
      const script = document.createElement('script')
      script.setAttribute('src', src)
      document.head.appendChild(script)
    }
  }
}

Vue.use({
  install() {
    Vue.prototype.$scriptLoader = scriptLoader
  }
})

var $ = window.jQuery = require('jquery');
if (navigator.userAgent.indexOf('Mac') > 0) {
  $('body').addClass('mac');
}

new Vue({
  render: h => h(App),
  router: router,
  store: store,
  interceptor,
  timestamp
}).$mount('#app')
